package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

@Serializable
data class GameModeDTO(
    val id: Long,
    val name: String
)
